import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IAlarmScheduleModel } from "../../services/alarm-schedule-data-service/Models";
import AlarmScheduleAdministrationDataService from "../../services/alarm-schedule-data-service/AlarmScheduleAdministrationService";


export type useAlarmSchedulesParams = {
    organizationID: number,
    groupID: number,
    includeLinkedAlarmSchemes: boolean,
} & BaseUseQueryParameters<IAlarmScheduleModel[]>;

export function useAlarmSchedules({
    organizationID,
    groupID,
    includeLinkedAlarmSchemes,
    enabled,    
    onSuccess,
    onError
}: useAlarmSchedulesParams) {
    return useQuery<IAlarmScheduleModel[], RestError>(
        keys.alarmSchedules(organizationID, groupID, includeLinkedAlarmSchemes),
        ({ signal }) => {
            return AlarmScheduleAdministrationDataService.getAlarmSchedules(
                organizationID,
                groupID,
                includeLinkedAlarmSchemes,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            //staleTime: 0,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,
        }
    );
}